import { authByToken } from 'src/services/auth/auth-by-token'
import { consoleLogAPI } from 'src/common/functions'
import { authBySession } from 'src/services/auth/auth-by-session'
import { getConfig } from 'src/configs'
import { SERVER_NOT_RESPONSE } from 'src/common/config'

const config = getConfig()

export default async function (apolloClient) {
  try {
    const OWN_SPORT = process.env.OWN_SPORT
    if (config.authBySession && !OWN_SPORT) {
      const isSuccessAuthBySession = await authBySession(apolloClient)

      if (!isSuccessAuthBySession) {
        await authByToken(apolloClient)
      }
    } else {
      await authByToken(apolloClient)
    }
  } catch (e) {
    if (e.message === SERVER_NOT_RESPONSE) {
      throw e
    }

    consoleLogAPI(e)
  }
}
